"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _Flag = _interopRequireDefault(require("@material-ui/icons/Flag"));
var _Link = _interopRequireDefault(require("@material-ui/icons/Link"));
var _Mail = _interopRequireDefault(require("@material-ui/icons/Mail"));
var _Save = _interopRequireDefault(require("@material-ui/icons/Save"));
var _links = require("../_utils/links");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _default;
  return {
    ctaText: {
      alignItems: 'inherit',
      justifyContent: 'inherit',
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14)
    },
    default: (_default = {
      textAlign: 'center',
      lineHeight: '24.5px',
      marginBottom: theme.spacing(6),
      padding: '10px 8px',
      borderRadius: theme.shape.borderRadius,
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(14),
      minWidth: '144px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center'
    }, (0, _defineProperty2.default)(_default, theme.breakpoints.up('sm'), {
      padding: '6px 8px'
    }), (0, _defineProperty2.default)(_default, '&.btn-primary', (0, _defineProperty2.default)({
      padding: '10px 24px'
    }, theme.breakpoints.up('sm'), {
      padding: '6px 24px'
    })), (0, _defineProperty2.default)(_default, '&.btn-secondary', (0, _defineProperty2.default)({
      padding: '9px 24px'
    }, theme.breakpoints.up('sm'), {
      padding: '5px 24px'
    })), _default),
    iconSpace: {
      marginTop: '0.1em',
      marginRight: '.375rem'
    }
  };
});
var ButtonEditConfig = {
  emptyLabel: 'Button',
  isEmpty: function isEmpty(props) {
    if (typeof props.text !== 'undefined' && props.text) {
      return false;
    } else {
      return true;
    }
  }
};
var Button = function Button(_ref) {
  var anchorId = _ref.anchorId,
    text = _ref.text,
    icon = _ref.icon,
    link = _ref.link,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'btn-primary' : _ref$theme,
    accessibilityLabel = _ref.accessibilityLabel,
    isAsset = _ref.isAsset,
    fileName = _ref.fileName,
    tagValue = _ref.tagValue,
    _ref$linkType = _ref.linkType,
    linkType = _ref$linkType === void 0 ? '_default' : _ref$linkType;
  var classes = useStyles();
  var defaultTarget = link && (0, _links.getTarget)(link);
  var linkProps = linkType === '_default' ? defaultTarget : {
    target: linkType
  };
  var getIconComponent = function getIconComponent(iconType) {
    if (!iconType) return;
    switch (iconType.toLowerCase()) {
      case 'add':
        return __jsx(_Add.default, {
          className: classes.iconSpace
        });
      case 'block':
        return __jsx(_Block.default, {
          className: classes.iconSpace
        });
      case 'clear':
        return __jsx(_Clear.default, {
          className: classes.iconSpace
        });
      case 'flag':
        return __jsx(_Flag.default, {
          className: classes.iconSpace
        });
      case 'link':
        return __jsx(_Link.default, {
          className: classes.iconSpace
        });
      case 'mail':
        return __jsx(_Mail.default, {
          className: classes.iconSpace
        });
      case 'save_alt':
        return __jsx(_Save.default, {
          className: classes.iconSpace
        });
      default:
        return null;
    }
  };
  return __jsx(_Box.default, {
    id: anchorId,
    display: "flex",
    alignItems: "center",
    className: "aem-ms-cta"
  }, text ? __jsx(_react.default.Fragment, null, link ? __jsx("a", (0, _extends2.default)({
    className: "aem-ms-cta--link ".concat(classes.default, " ").concat(theme)
  }, linkProps, {
    "aria-label": accessibilityLabel,
    href: link,
    "data-event": isAsset ? 'download' : null,
    "data-dlname": fileName ? fileName : null,
    "data-dltype": tagValue ? tagValue : null
  }), icon && getIconComponent(icon), __jsx("span", {
    className: classes.ctaText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })) : __jsx("button", {
    className: "aem-ms-cta--button ".concat(classes.default, " ").concat(theme),
    "aria-label": accessibilityLabel
  }, icon && getIconComponent(icon), __jsx("span", {
    className: classes.ctaText,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }))) : null);
};
var _default2 = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/button')(Button, ButtonEditConfig);
exports.default = _default2;